import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-signin-qr-dialog',
  templateUrl: './signin-qr-dialog.component.html',
  styleUrls: ['./signin-qr-dialog.component.scss'],
})
export class SigninQrDialogComponent implements OnInit {
  iosApp: string = environment.iosApp;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { secondsToExpire: number; encodedToken: string },
    public dialogRef: MatDialogRef<SigninQrDialogComponent>,
  ) {}
  ngOnInit(): void {
    setTimeout(() => {
      this.dialogRef.close('EXPIRED TOKEN');
    }, 300000);
  }

  goToApplication() {
    if (/Windows/i.test(navigator.userAgent)) {
      window.open('https://play.google.com/store/apps/details?id=com.tiendacrypto&hl=es');
    } else {
      window.open('https://apps.apple.com/app/id1643834748');
    }
  }
}
